export const SET_START_TIME = 'DATE_PICKER/SET_START_TIME';
export const SET_END_TIME = 'DATE_PICKER/SET_END_TIME';

export const setStartTime = (startTime) => ({ type: SET_START_TIME, startTime });
export const setEndTime = (endTime) => ({ type: SET_END_TIME, endTime });

export const initialTimeState = {
  startTime: null,
  endTime: null,
};

export const timeReducer = (state, action) => {
  switch (action.type) {
    case SET_START_TIME: {
      return {
        ...state,
        startTime: action.startTime,
      };
    }
    case SET_END_TIME: {
      return {
        ...state,
        endTime: action.endTime,
      };
    }
    default:
      return state;
  }
};
